import { useState, useEffect } from "react";
import logoAsset from "@/assets/rietkuil-logo-clean-transparent.png";

const navLinks = [
  { label: "About", id: "about" },
  { label: "Rooms", id: "rooms" },
  { label: "Amenities", id: "amenities" },
  { label: "House Rules", id: "house-rules" },
  { label: "Gallery", id: "gallery" },
  { label: "Location", id: "location" },
  { label: "Check Availability", id: "availability" },
];

export default function Navbar({ onNav }: { onNav: (id: string) => void }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (id: string) => { onNav(id); setMenuOpen(false); };

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-700"
      style={scrolled
        ? { backgroundColor: "rgba(240,235,224,0.96)", backdropFilter: "blur(12px)", borderBottom: "1px solid #C8C0B4" }
        : { backgroundColor: "transparent" }
      }
    >
      <div className="mx-auto px-8 md:px-14 py-5 flex items-center justify-between gap-8">
        <button className="flex items-center cursor-pointer shrink-0" onClick={() => { window.location.href = "/auth"; }}>
          <img
            src={logoAsset}
            alt="Rietkuil Farm House"
            className="h-20 md:h-24 w-auto transition-all duration-700"
            style={{
              filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.15))",
            }}
          />
        </button>

        <div className="hidden md:flex items-center justify-center flex-1 gap-10">
          {navLinks.map((link) => (
            <button key={link.id} onClick={() => handleNav(link.id)}
              className="text-sm font-sans font-medium tracking-[0.1em] uppercase transition-colors whitespace-nowrap cursor-pointer"
              style={{ color: scrolled ? "#6E5E40" : "rgba(255,255,255,0.75)" }}
              onMouseEnter={e => (e.currentTarget.style.color = scrolled ? "#3C3530" : "rgba(255,255,255,0.95)")}
              onMouseLeave={e => (e.currentTarget.style.color = scrolled ? "#6E5E40" : "rgba(255,255,255,0.75)")}
            >
              {link.label}
            </button>
          ))}
          <button onClick={() => handleNav("booking")}
            className="px-6 py-2.5 text-sm font-sans font-medium tracking-widest uppercase transition-all whitespace-nowrap cursor-pointer rounded-full border"
            style={scrolled
              ? { borderColor: "#6E5E40", color: "#6E5E40" }
              : { borderColor: "rgba(255,255,255,0.3)", color: "rgba(255,255,255,0.7)" }
            }
            onMouseEnter={e => {
              if (scrolled) { e.currentTarget.style.backgroundColor = "#4E4228"; e.currentTarget.style.color = "#F5F0E8"; }
              else { e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.1)"; }
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = scrolled ? "#6E5E40" : "rgba(255,255,255,0.7)";
            }}
          >
            Book a Stay
          </button>
        </div>

        <button className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer" onClick={() => setMenuOpen(!menuOpen)}>
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}
            style={{ color: scrolled ? "#3C3530" : "rgba(255,255,255,0.8)" }}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden px-8 py-6 flex flex-col gap-5" style={{ backgroundColor: "#F0EBE0", borderTop: "1px solid #C8C0B4" }}>
          {navLinks.map((link) => (
            <button key={link.id} onClick={() => handleNav(link.id)}
              className="text-sm font-sans font-medium tracking-[0.1em] uppercase text-left cursor-pointer"
              style={{ color: "#7E7265" }}>
              {link.label}
            </button>
          ))}
          <button onClick={() => handleNav("booking")}
            className="px-6 py-2.5 text-sm font-sans font-medium tracking-widest uppercase border whitespace-nowrap cursor-pointer w-fit rounded-full transition-all"
            style={{ borderColor: "#6E5E40", color: "#6E5E40" }}>
            Book a Stay
          </button>
          <a href="/auth"
            className="text-xs font-sans tracking-[0.1em] uppercase cursor-pointer mt-2"
            style={{ color: "#7E7265" }}>
            Owner Login
          </a>
        </div>
      )}
    </nav>
  );
}
